"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * iPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.15.7
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MentorSprintApi = exports.MentorSprintApiFactory = exports.MentorSprintApiFp = exports.MentorSprintApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * MentorSprintApi - axios parameter creator
 * @export
 */
exports.MentorSprintApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get team deliverables
         * @param {string} id
         * @param {string} teamId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamDeliverables: (id, teamId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            common_1.assertParamExists('getTeamDeliverables', 'id', id);
            // verify required parameter 'teamId' is not null or undefined
            common_1.assertParamExists('getTeamDeliverables', 'teamId', teamId);
            const localVarPath = `/sprint/{id}/team/{teamId}/deliverable`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * MentorSprintApi - functional programming interface
 * @export
 */
exports.MentorSprintApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.MentorSprintApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get team deliverables
         * @param {string} id
         * @param {string} teamId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamDeliverables(id, teamId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTeamDeliverables(id, teamId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * MentorSprintApi - factory interface
 * @export
 */
exports.MentorSprintApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.MentorSprintApiFp(configuration);
    return {
        /**
         *
         * @summary Get team deliverables
         * @param {string} id
         * @param {string} teamId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamDeliverables(id, teamId, options) {
            return localVarFp.getTeamDeliverables(id, teamId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * MentorSprintApi - object-oriented interface
 * @export
 * @class MentorSprintApi
 * @extends {BaseAPI}
 */
class MentorSprintApi extends base_1.BaseAPI {
    /**
     *
     * @summary Get team deliverables
     * @param {string} id
     * @param {string} teamId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MentorSprintApi
     */
    getTeamDeliverables(id, teamId, options) {
        return exports.MentorSprintApiFp(this.configuration).getTeamDeliverables(id, teamId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.MentorSprintApi = MentorSprintApi;
